export default (function (value) {
  return value instanceof Map;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isMap.js
// module id = ./node_modules/redux-actions/es/utils/isMap.js
// module chunks = 6 9 11